import EventEmitter from '../classes/EventEmiter'
import type {
  IContainers,
  IProcessedComponent,
  IProcessedComponentProps,
  IProcessedContainer,
  UnresolvedRecord,
} from '../interfaces'
import { RootState } from '../redux/store'
import { processActions } from '../utils/processActions'
import processData from '../utils/processData'
import { isHidePricesEnabled } from '../utils/hidePrices'
import maskPricesForDisplay from '../utils/maskPricesForDisplay'

const resolveProps = (data: UnresolvedRecord, state: RootState) => {
  const resolved = processData(data, { state })
  if (!isHidePricesEnabled(state)) return resolved
  return maskPricesForDisplay(resolved)
}

const getCinnamonProps = <T = unknown>(
  props: UnresolvedRecord,
  state: RootState,
  eventEmitter: EventEmitter,
): IProcessedComponentProps<T> => {
  const cinnamonProps = resolveProps(props, state)
  return processActions(cinnamonProps, eventEmitter)
}

const processDataValidated = (
  data: UnresolvedRecord | undefined = {},
  state: RootState,
) => resolveProps(data, state)

export const getCinnamonPropsContainer = (
  { header, body, footer, modals, uid }: IContainers,
  state: RootState,
  eventEmitter: EventEmitter,
): IProcessedContainer => {
  return {
    uid,
    modals,
    header: {
      props: processDataValidated(header?.props, state),
      components:
        header?.components.map<IProcessedComponent>(
          ({ props = {}, ...rest }) => ({
            ...rest,
            props: getCinnamonProps(props, state, eventEmitter),
          }),
        ) || [],
    },
    body: {
      props: processDataValidated(body?.props, state),
      components: body?.components.map<IProcessedComponent>(
        ({ props = {}, ...rest }) => ({
          ...rest,
          props: getCinnamonProps(props, state, eventEmitter),
        }),
      ),
    },
    footer: {
      props: processDataValidated(footer?.props, state),
      components:
        footer?.components.map<IProcessedComponent>(
          ({ props = {}, ...rest }) => ({
            ...rest,
            props: getCinnamonProps(props, state, eventEmitter),
          }),
        ) || [],
    },
  }
}

export default getCinnamonProps
